import * as $runtime from "../runtime.js";
import * as Data$dBigInt from "../Data.BigInt/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dException from "../Effect.Exception/index.js";
import * as Web$dHTML$dEvent$dErrorEvent from "../Web.HTML.Event.ErrorEvent/index.js";
import * as Web$dInternal$dFFI from "../Web.Internal.FFI/index.js";
import * as Web$dWorker$dMessageEvent from "../Web.Worker.MessageEvent/index.js";
import * as Web$dWorker$dWorker from "../Web.Worker.Worker/index.js";
import {createWorker} from "./foreign.js";
const run = param => Effect$dAff.makeAff(reply => () => {
  const worker = createWorker();
  Web$dWorker$dWorker.onMessage(event => reply((() => {
    const $0 = Effect$dException.error("BigInt.fromString");
    const $1 = Data$dBigInt.fromString(Web$dWorker$dMessageEvent.data_(event));
    if ($1.tag === "Nothing") { return Data$dEither.$Either("Left", $0); }
    if ($1.tag === "Just") { return Data$dEither.$Either("Right", $1._1); }
    $runtime.fail();
  })()))(worker)();
  Web$dWorker$dWorker.onError(event => {
    const $0 = Web$dWorker$dWorker.terminate(worker);
    return () => {
      $0();
      return reply(Data$dEither.$Either(
        "Left",
        Effect$dException.error((() => {
          const $1 = Web$dInternal$dFFI._unsafeReadProtoTagged(Data$dMaybe.Nothing, Data$dMaybe.Just, "ErrorEvent", event);
          if ($1.tag === "Nothing") { return "Unknown worker error"; }
          if ($1.tag === "Just") { return Web$dHTML$dEvent$dErrorEvent.message($1._1); }
          $runtime.fail();
        })())
      ))();
    };
  })(worker)();
  Web$dWorker$dWorker.postMessageImpl(param)([])(worker)();
  const $0 = Effect$dAff._liftEffect(Web$dWorker$dWorker.terminate(worker));
  return v => $0;
});
export {run};
export * from "./foreign.js";
